export default class Filters {
  constructor({el, args = '', type = 'post', submit, fetch, limit = -1, error}) {
    this.el = el
    this.type = type
    this.limit = limit
    this.submit = submit
    this.fetch = fetch
    this.page = 0
    this.errorEl = error
    this.args = args
    this.baseUrl = `type=${this.type}&limit=${this.limit}${this.args}`

    this.getElems()
    this.events()
    this.checkUrlParams()
  }

  getElems() {
    this.selects = []
    this.type_filter = this.el.querySelectorAll('.filter')
    this.filters = this.el.querySelectorAll('.filter input')
    this.error = this.errorEl || document.querySelector('.filters__error')
    this.showMore = this.el.querySelector('.filter-more')
    this.showLess = this.el.querySelector('.filter-less')
    this.additionnals = this.el.querySelector('.filter-additionnals')

    this.filter = []

    for (let i = 0; i < this.type_filter.length; i++) {
      this.filter[i] = {
        name: this.type_filter[i].dataset.name,
        items: this.type_filter[i].querySelectorAll('.filter input')
      }
    }

    for (let i = 0; i < this.filters.length; i++) this.selects[this.filters[i].name] = this.filters[i]
  }

  events() {
    this.filters.forEach((item) => {
      item.addEventListener('change', this.onSubmit.bind(this))
    })

    this.showMore && this.showMore.addEventListener('click', this.showFilters.bind(this))
    this.showLess && this.showLess.addEventListener('click', this.hideFilters.bind(this))
  }

  onSubmit() {
    this.url = this.baseUrl

    for (let i = 0; i < this.filter.length; i++) {
      const filter = this.filter[i]

      filter.items.forEach((item) => {
        if (item.checked) this.url += `&${filter.name}[]=${item.name}`
      })
    }

    this.submit && this.submit()
    this.fetchPosts(this.url, false)
  }

  fetchPosts(url, changePage = false) {
    const init = {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }

    if (changePage) this.page++
    else this.page = 0

    document.body.style.cursor = 'wait'

    fetch(`/wp-json/digitalcover/filter_posts/?${url}&page=${this.page}`, init).then((query) => {
      query.json()
        .then((resp) => {
          document.body.style.cursor = 'inherit'
          this.error.classList.toggle('active', resp.length <= 0 && this.page === 0)
          this.fetch && this.fetch(resp, url, this.page)
        })
        .catch((error) => {
          console.log(error)
        })
    })
  }

  checkUrlParams() {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(urlSearchParams.entries())

    this.url = this.baseUrl

    if (Object.keys(params).length === 0 && params.constructor === Object) return

    Object.entries(params).forEach(([key, value]) => {
      this.url += `&${key}=${value}`
      if (this.selects[key]) this.selects[key].value = value
    })

    this.submit && this.submit()
    this.fetchPosts(this.url)
  }

  showFilters() {
    this.showMore.style.display = 'none'
    this.showLess.style.display = 'block'
    this.additionnals.classList.add('visible')
  }

  hideFilters() {
    this.showMore.style.display = 'block'
    this.showLess.style.display = 'none'
    this.additionnals.classList.remove('visible')
  }
}



// WEBPACK FOOTER //
// ./scripts/util/Filters.js